import React from 'react';

import { OrderDocumentOutputType } from '../../../../entities';

export const useOutputDocumentStatus = (data, isOutputDocuments, changeIsLoading, changeIsUnloading) => {
	React.useEffect(() => {
		if (isOutputDocuments && data) {
			for (let documentFile of data) {
				if (documentFile.type === OrderDocumentOutputType.loading) {
					changeIsLoading(true);
				} else if (documentFile.type === OrderDocumentOutputType.unloading) {
					changeIsUnloading(true);
				}
			}
		}
	}, [data, isOutputDocuments, changeIsLoading, changeIsUnloading]);
};
